<template>
	<div>
		<div class="costs max4digits">
			<span v-if="!checkStorage">
				<span
					v-for="(type, index) in resTypes"
					:key="index"
					v-show="hideZero ? resources[index] > 0 : resourceVisibility[index]"
					class="resource"
					:class="[
						type.type+'Value',
						{
							notEnough: !enoughStorage(index, resources[index]),
							enough: enoughStorage(index, resources[index]) && colorPositive
						}
					]"
					v-tippy="{placement: 'bottom'}"
					:content="type.name"
				>
					<i :class="['unit_'+type.type+'_small_illu', 'resType'+(index + 1)]"></i>
					<span
						v-if="!onlyProductionPerHour"
						class="resourceValue"
						:class="{
							strikethrough: showAsOldResources
						}"
					>
						<span>&nbsp;</span>
						<span v-if="signed">+</span>
						<span>{{resources[index]}}</span>
						<span v-if="percent">%</span>
					</span>
					<!-- ngIf: ::numberUnit=='production' -->
					<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
				</span>
			</span>
			<span v-if="checkStorage">
				<span
					v-for="(type, index) in resTypes"
					:key="index"
					v-show="hideZero ? resources[index] > 0 : resourceVisibility[index]"
					class="resource"
					:class="[
						type.type+'Value',
						{
							notEnough: !enoughStorage(index, resources[index]),
							enough: enoughStorage(index, resources[index]) && colorPositive
						}
					]"
					v-tippy="{placement: 'bottom'}"
					:content="type.name"
				>
					<i :class="['unit_'+type.type+'_small_illu', 'resType'+(index + 1)]"></i>
					<span
						v-if="!onlyProductionPerHour"
						class="resourceValue"
						:class="{
							strikethrough: showAsOldResources
						}"
					>
						<span>&nbsp;</span>
						<span v-if="signed">+</span>
						<span>{{resources[index]}}</span>
						<span v-if="percent">%</span>
					</span>
					<!-- ngIf: ::numberUnit=='production' -->
					<!-- ngIf: productionPerHour[index] || productionPerHour[index] == 0 -->
				</span>
			</span>
			<span
				v-if="(consumption || consumption == 0)"	
				class="resource consumptionValue"
				v-tippy="{placement: 'bottom'}"
				content="Потребление"
			>
				<i class="unit_consumption_small_flat_black"></i>
				<span>&nbsp;+{{consumption}}</span>
			</span>
			<!-- ngIf: population || population == 0 -->
			<!-- ngIf: treasures || treasures == 0 -->
			<span
				v-if="stolenGoods || stolenGoods == 0"
				class="resource treasureValue"
				v-tippy="{placement: 'bottom'}"
				content="Краденые ценности"
			>
				<i class="unit_stolenGoods_small_illu"></i>
				<span>&nbsp;{{stolenGoods}}</span>
			</span>
			<span
				v-if="time || time == 0"
				class="resource timeValue"
				v-tippy="{placement: 'bottom'}"
				content="Время"
			>
				<i class="symbol_clock_small_flat_black duration"></i>
				<span>&nbsp;{{formatSecondsDate(time, 'HH:mm:ss')}}</span>
			</span>
			<div
				v-if="checkStorage && capacityHintStorage"
				class="enoughResTime"
			>
				<div v-if="capacityHintStorage">Недостаточно места на складе</div>
			</div>
			<div
				v-if="showNpc"
				class="iconButton premium npcTrade"
			>
				<i class="feature_npcTrader_small_flat_black"></i>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	
</style>

<script>
import lib from '@/lib';

export default {
	props: {
		resources: { // ресурсы
			type: Array,
			required: true,
			default: [0, 0, 0, 0, 0],
		},
		consumption: { // потребление
			type: Number,
		},
		stolenGoods: { // краденые ценности
			type: Number,
		},
		time: { // время
			type: Number,
		},
		checkStorage: { // проверка на переполнение склада
			type: Boolean,
			default: false,
		},
		colorPositive: { // цвет положительный
			type: Boolean,
			default: false,
		},
		hideZero: { // скрывать нулевые ресурсы
			type: Boolean,
			default: false,
		},
		onlyProductionPerHour: { // показывать только производство в час
			type: Boolean,
			default: false,
		},
		resourceVisibility: { // видимость ресурсов
			type: Array,
			default: [
				true,
				true,
				true,
				true,
				true,
			],
		},
		showAsOldResources: { // отображать ресурсы зачеркнутыми
			type: Boolean,
			default: false,
		},
		percent: { // отображать знак процента после каждого ресурса
			type: Boolean,
			default: false,
		},
		signed: { // отображать знак + перед каждым ресурсом
			type: Boolean,
			default: false,
		},
		showNpc: { // отображать кнопку NPC Trader
			type: Boolean,
			default: false,
		},
		gameModel: { // модель игры
			type: Object,
			required: true,
		},
	},
	data: () => ({
		
	}),
	computed: {
		resTypes() {
			return this.gameModel?.island?.storage?.resTypes||{};
		},
		// есть ли переполнение склада хотя-бы по одному ресурсу в случае его получения
		capacityHintStorage() {
			let enough = false;
			for (let [index, resType] of Object.entries(this.resTypes)) {
				if (!this.enoughStorage(index, this.resources[index])) {
					enough = true;
					break;
				}
			}
			return enough;
		},
	},
	methods: {
		formatSecondsDate: lib.formatSecondsDate,
		
		// влезает ли на склад
		enoughStorage(resTypeIndex, value) {
			return this.gameModel.island.storage.hasEnoughStorage(resTypeIndex, value);
			//return value <= this.gameModel.island.storage[this.resTypes[resTypeIndex].type+'CountMax'];
		},
	},
}
</script>